import type { Country } from '@bb/domain/dist/types';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetExternalTemplateOptions = {
  retsId?: string;
  dashboardId?: string;
  type?: 'ackTemplate' | string;
  country?: Country;
};

const getExternalTemplate = async ({
  retsId,
  dashboardId,
  type,
  country,
}: GetExternalTemplateOptions) => {
  const config: AxiosRequestConfig = {
    url: '/external/covid19/settings',
    method: 'get',
    params: {
      retsId,
      dashboardId,
      type,
      country,
    },
  };

  const { data } = await axios.request<string>(config);

  return data;
};

export default getExternalTemplate;
